import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export var TableBase = function (props) {
    var primaryDimensionList = props.primaryDimensionList, secondaryDimensionList = props.secondaryDimensionList, direction = props.direction, wrapping = props.wrapping, multiBody = props.multiBody;
    return (React.createElement(RampWithNameTransform, { rampName: "ContextContainer", primaryDimensionList: primaryDimensionList, secondaryDimensionList: secondaryDimensionList, direction: direction, wrapping: wrapping, multiBody: multiBody },
        React.createElement(RampWithNameTransform, { rampName: "Container" },
            React.createElement(RampWithNameTransform, { rampName: "Content" }))));
};
